// extracted by mini-css-extract-plugin
module.exports = {"form":"searchInput-module--form--qUpK_","formInput":"searchInput-module--formInput--1M3CI","formButton":"searchInput-module--formButton--33q6z"};